import storageRepository from "./storageRepository";

const { normalizeCustomListIds } = require("../helpers/customListArchive.js");

export default {
    load() {
        let customToDoList = storageRepository.get('customTodoListIds');
        if (customToDoList) {
            return normalizeCustomListIds(customToDoList);
        } else {
            storageRepository.set('customTodoListIds', []);
            return [];
        }
    },
    update(customToDoList) {
        storageRepository.set('customTodoListIds', normalizeCustomListIds(customToDoList));
    }
};